"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendPage = exports.appendTags = exports.appendFilter = exports.appendIp = exports.appendAuthorization = exports.toAuthHeader = exports.toHeader = exports.toTimeout = exports.toStringMap = void 0;
/**
 * toQuery
 *
 * Shallow copies object while omitting undefined attributes
 */
exports.toStringMap = function (optional) {
    if (optional === undefined)
        return {};
    return Object.keys(optional).reduce(function (result, key) {
        var value = optional[key];
        var reduce = reduceStringMap(value);
        if (reduce.length > 0)
            result[key] = reduce;
        return result;
    }, {});
};
var isString = function (i) { return typeof i === "string"; };
var isArray = function (i) { return Array.isArray(i); };
var reduceStringMap = function (value) {
    var result = [];
    if (isArray(value)) {
        value.forEach(function (val) {
            if (isNumber(val))
                result.push(val.toString());
            if (isString(val))
                result.push(val);
        });
        return result.join(",");
    }
    if (isNumber(value))
        return value.toString();
    if (isString(value))
        return value;
    return "";
};
var isNumber = function (n) { return typeof n === "number"; };
/**
 * toTimeout
 *
 * Returns timeout value from request object. Delegates to default client
 * timeout if not specified
 */
exports.toTimeout = function (_a, client) {
    var timeout = _a.timeout;
    if (isNumber(timeout))
        return timeout;
    return client.timeout;
};
/**
 * toHeader
 *
 * Extracts HTTP Header object from request and client default headers
 *
 * Precendence is given to request specific headers
 */
exports.toHeader = function (_a, client) {
    var _b = _a.header, header = _b === void 0 ? {} : _b;
    return __assign(__assign({}, client.header), exports.toStringMap(header));
};
/**
 * toAuthHeader
 *
 * Extracts credentials into authorization header format
 */
exports.toAuthHeader = function (client, options) {
    var credentials = [];
    var api_key = options.api_key || client.api_key;
    credentials.push(["api_key", api_key]);
    var licensee = options.licensee;
    if (licensee !== undefined)
        credentials.push(["licensee", licensee]);
    var user_token = options.user_token;
    if (user_token !== undefined)
        credentials.push(["user_token", user_token]);
    return "IDEALPOSTCODES " + toCredentialString(credentials);
};
/**
 * appendAuthorization
 *
 * Mutates a headers object to include Authorization header. Will insert if found:
 * - api_key
 * - licensee
 * - user_token
 */
exports.appendAuthorization = function (_a) {
    var header = _a.header, options = _a.options, client = _a.client;
    header.Authorization = exports.toAuthHeader(client, options);
    return header;
};
var toCredentialString = function (credentials) {
    return credentials.map(function (_a) {
        var key = _a[0], value = _a[1];
        return key + "=\"" + value + "\"";
    }).join(" ");
};
// Adds source IP to headers
exports.appendIp = function (_a) {
    var header = _a.header, options = _a.options;
    var sourceIp = options.sourceIp;
    if (sourceIp !== undefined)
        header["IDPC-Source-IP"] = sourceIp;
    return header;
};
// Adds filters to query
exports.appendFilter = function (_a) {
    var query = _a.query, options = _a.options;
    var filter = options.filter;
    if (filter !== undefined)
        query.filter = filter.join(",");
    return query;
};
// Adds tags to query
exports.appendTags = function (_a) {
    var query = _a.query, options = _a.options;
    var tags = options.tags;
    if (tags !== undefined)
        query.tags = tags.join(",");
    return query;
};
// Adds pagination attributes to query
exports.appendPage = function (_a) {
    var query = _a.query, options = _a.options;
    var page = options.page, limit = options.limit;
    if (page !== undefined)
        query.page = page.toString();
    if (limit !== undefined)
        query.limit = limit.toString();
    return query;
};
//# sourceMappingURL=util.js.map